import React from 'react';

import { Container, Title, Button, Image } from 'ui/components/styled';
import { AuthLayout } from 'ui/components/layouts';
import { useUser } from 'hooks';

export const TFASuccess = () => {
  const { challenges, redirectToDashboard } = useUser();

  return (
    <AuthLayout show={challenges.required} justifyContent="start">
      <Container width="80%" maxWidth="480px" height="auto" top="15%">
        <Container alignItems="center" mb="xl">
          <Image alt="2FA" src="/assets/img/2FA.png" />
        </Container>
        <Title mb="m">Success</Title>
        <Title type="h3" variant="grey" mb="xs">
          Your Authenticator App is configured and you are now ready to use 2FA. You will be asked
          to use 2FA the next time you sign in.
        </Title>
        <Button type="submit" my="m" onClick={() => redirectToDashboard()}>
          DONE
        </Button>
      </Container>
    </AuthLayout>
  );
};
